import { useRemoteCombobox } from '@/setup/remoteCombobox.js';
import { reactive, getCurrentInstance, ref, computed } from 'vue';

export const useCAPaymentDetailData = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData, submitQuickAdd } = useRemoteCombobox();

  // Init các field của grid detail
  const initGridColumnParallel = () => {
    return [
      {
        caption: 'Diễn giải',
        dataField: 'description',
        columnType: proxy.$ms.constant.ColumnType.Text,
        width: 250,
        editable: true,
        sortable: true,
      },
      {
        caption: 'TK Nợ',
        title: 'Tài khoản Nợ',
        dataField: 'debit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'TK Có',
        title: 'Tài khoản Có',
        dataField: 'credit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Số tiền',
        dataField: 'amount_oc',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Quy đổi',
        dataField: 'amount',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        rules: [{ name: 'lessThanAmount', compareValue: 100000000000000 }],
        visible: false,
        sortable: true,
      },
      {
        width: 136,
        caption: 'Mã dự phòng',
        dataField: 'budget_provide_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Nguồn',
        dataField: 'budget_source_name',
        width: 250,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Loại',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        dataField: 'budget_kind_item_code',
        editable: true,
        sortable: true,
        visible: false,
        width: 100,
      },
      {
        caption: 'Chương',
        dataField: 'budget_chapter_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Khoản',
        dataField: 'budget_sub_kind_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mục',
        dataField: 'budget_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiểu mục',
        dataField: 'budget_sub_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiết tiểu mục',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        dataField: 'budget_detail_item_code',
        editable: true,
        sortable: true,
        visible: false,
        width: 100,
      },
      {
        caption: 'Số lượng',
        columnType: proxy.$ms.constant.ColumnType.Number,
        dataField: 'quantity',
        editable: true,
        sortable: true,
        visible: false,
        width: 136,
      },
      {
        caption: 'Định mức',
        columnType: proxy.$ms.constant.ColumnType.Number,
        dataField: 'norm',
        editable: true,
        sortable: true,
        visible: false,
        width: 136,
      },
      {
        caption: 'Đơn giá',
        columnType: proxy.$ms.constant.ColumnType.Number,
        dataField: 'unitprice',
        editable: true,
        sortable: true,
        visible: false,
        width: 136,
      },
      {
        caption: 'Đối tượng',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        dataField: 'accounting_object_code',
        editable: true,
        sortable: true,
        visible: false,
        width: 136,
      },
      {
        caption: 'Cấp phát',
        dataField: 'method_distribute_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 136,
        sortable: true,
        enum: 'MethodDistributeType',
      },
      {
        caption: 'Mã thống kê',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        dataField: 'statistic_code',
        editable: true,
        sortable: true,
        visible: false,
        width: 136,
      },
      {
        caption: 'Ghi chú',
        columnType: 0,
        dataField: 'note',
        editable: true,
        sortable: true,
        visible: false,
        width: 250,
      },
      {
        caption: 'Nghiệp vụ',
        dataField: 'cash_withdraw_type_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 136,
        sortable: true,
        enum: 'CashWithDrawType',
      },
      {
        caption: 'Nguồn năm trước',
        columnType: proxy.$ms.constant.ColumnType.Checkbox,
        dataField: 'is_source_before_year',
        editable: true,
        sortable: true,
        visible: false,
        width: 136,
      },
      {
        caption: 'Hoạt động',
        dataField: 'activity_name',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        sortable: true,
      },
      {
        caption: 'CTMT, dự án',
        title: 'Chương trình mục tiêu, dự án',
        dataField: 'project_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        sortable: true,
      },
      {
        caption: 'Tài khoản NH, KB',
        title: 'Tài khoản ngân hàng, kho bạc',
        dataField: 'bank_account',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 160,
        sortable: true,
      },
      {
        caption: 'Phí, lệ phí',
        title: 'Phí, lệ phí',
        dataField: 'budget_fees_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        width: 100,
        caption: 'Đề tài',
        editable: true,
        sortable: true,
        dataField: 'topic_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        filterable: true,
      },
      {
        width: 100,
        caption: 'Hợp đồng',
        editable: true,
        sortable: true,
        dataField: 'contract_no',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
      },
      {
        width: 100,
        caption: 'Nhiệm vụ',
        dataField: 'task_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: '',
        dataField: 'rowAction',
        width: 80,
        columnType: proxy.$ms.constant.ColumnType.Action,
        sortable: false,
      },
    ];
  };

  // column thuế

  // Khởi tạo các field của grid
  const columnParallel = reactive(initGridColumnParallel());

  /**
   * Biến dùng để disabled Sinh chứng từ chuyển khoản KB vào TK tiền gửi
   * TPNAM 26.04.2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến lưu trạng thái của form khi ở mode view
   * NVTUAN1 09.08.2022
   */
  const valueModeView = computed(() => {
    return proxy.editMode == proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled Xóa nếu chứng từ đã ghi sổ
   * NCQUYEN 19.04.2022
   */
  const disabledDelete = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
  });
  // item của button tiện ích
  const buttonUtilities = reactive([
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
      IsSubMenu: true,
      subItem: [
        {
          text: 'Phiếu thu',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptDetail',
          refType: proxy.$ms.constant.RefType.CAReceipt
        },
        {
          text: 'Phiếu thu rút dự toán nhập quỹ',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptPlanWithdrawDetail',
          refType: proxy.$ms.constant.RefType.CAReceiptPlanWithdraw
        },
        {
          text: 'Phiếu chi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAPaymentDetail',
          refType: proxy.$ms.constant.RefType.CAPayment,
          initial: true
        },
        {
          text: 'Chuyển khoản kho bạc',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUTransferDetail',
          refType: proxy.$ms.constant.RefType.BUTransfer
        },
        {
          text: 'Chứng từ nghiệp vụ khác',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'GLGeneralVoucherDetail',
          refType: proxy.$ms.constant.RefType.GLGeneralVoucher
        },
        {
          text: 'Chi tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BAWithDrawDetail',
          refType: proxy.$ms.constant.RefType.BAWithDraw
        },
        {
          text: 'Thu tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BADepositDetail',
          refType: proxy.$ms.constant.RefType.BADeposit
        },
      ]
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   disabledItem: disabledDelete,
    // },
    {
      text: 'Xem số dư tài khoản',
      command: 'ViewAccount',
    },
    {
      text: 'Xem số dư tạm ứng',
      command: proxy.$ms.constant.Command.ViewAdvanceBalance,
    },
    {
      text: 'Hạch toán chi phí lương',
      command: 'GLVoucherDetail',
      disabledItem: valueMode,
    },
    {
      text: 'Sao chép chứng từ',
      command: proxy.$ms.constant.Command.Copy,
      disabledItem: valueModeView,
    },
    {
      text: 'Cất thành định khoản tự động',
      command: 'AddAutoBusiness',
    },
  ]);

  // item button in
  const buttonPrints = [
    { text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)' },
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP) (Mẫu dọc - tùy chỉnh)',
    },
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP) (Mẫu đọc)',
    },
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP) (Mẫu tùy chỉnh)',
    },
    { text: 'Bảng kê nộp thuế (Nghị định 11/2020/NĐ-CP)' },
    { text: 'C37-HD: Giấy đề nghị thanh toán' },
    { text: 'C41-BB: Phiếu chi' },
    { text: 'C41-BB: Phiếu chi (2 liên)' },
    { text: 'C41-HD: Bảng kê đề nghị thanh toán' },
    { text: 'Chứng từ kế toán' },
    { text: 'Chứng từ kế toán (Mẫu nguyên tệ)' },
    { text: 'Giấy đề nghị thanh toán tạm ứng' },
    { text: 'C37-HD: Giấy đề nghị thanh toán (Mẫu chi tiết từng dòng)' },
    { text: 'C41-BB: Phiếu chi (2 liên - Mẫu tiểu mục)' },
    { text: 'C41-BB: Phiếu chi (2 liên A5)' },
    { text: 'C41-BB: Phiếu chi (Giấy cuộn - A5)' },
    { text: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)' },
    { text: 'C41-BB: Phiếu chi (Mẫu tiểu mục)' },
    { text: 'C41-BB: Phiếu chi (nhiều dòng)' },
    { text: 'C42-HD: Giấy đề nghị tạm ứng', seperatorBottom: true },
    { text: 'Tùy chọn in...' },
  ];

  // Định khoản nhanh trong form detail chuyển khoản kho bạc
  const autoBusiness = [
    {
      text: 'Rút tạm ứng chưa cấp dự toán chi các khoản chi phí khác p/v HĐKTX',
      command: 'receipt',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán chi các khoản chi phí khác p/v HĐTX',
      command: 'receipt',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán KPTX nộp BHXH, BHYT, BHTN',
      command: 'receipt',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán KPTX trả lương cho CB CNV',
      command: 'receipt',
    },
    {
      text: 'Rút tạm ứng chưa cấp dự toán mua văn phòng phẩm HĐ không thường xuyên',
      command: 'receipt',
      seperatorBottom: true,
    },
    { text: 'Định khoản tự động', command: 'receipt' },
  ];

  return {
    autoBusiness,
    buttonUtilities,
    buttonPrints,
    columnParallel,
    // func combo
    submitQuickAdd,
    comboboxLoadData,
  };
};
